<section
    [ngStyle]="{
        'background-color': get(tableRow, 'exxcom_color_picker', ''),
        'background-repeat': 'no-repeat',
        'margin-bottom': get(tableRow, 'exxcom_color_picker', '').length > 0 ? '24px' : ''
    }"
  [class.no-padding]="hidePreviewElements"
  class="non-modal-table-styles"
  >
  @if (get(tableRow, 'old_or_new_table', '') != 'new_table') {
    <div>
      <div>
        <div class="container-padless d-flex flex-column align-items-center">
          <div class="category-top-title d-flex justify-content-center pb-2">
            @if (get(tableRow, 'headline', '')) {
              <h2 class="col-md-7 text-center">
                {{ get(tableRow, 'headline', '') }}
              </h2>
            }
          </div>
          <div class="px-2" id="tables" [innerHTML]="get(tableRow, 'table_content', '') | safe: 'html'"></div>
        </div>
      </div>
    </div>
  }

  @if (get(tableRow, 'old_or_new_table', '') == 'new_table') {
    <div class="container new-table">
      @if (activatePreview && !hidePreviewElements) {
        <div
          id="preview-table-container"
          class="d-flex flex-column align-items-center"
          [class.invalid-preview]="tabbedAndStackedLength < 2 && tableType == 'tabbed_and_stacked'"
          >
          <h2>{{ get(tableRow, 'headline', '') }}</h2>
          <button-component
            class="preview-button"
            (click)="openTable(tableTypeRef); isTableOpen = true"
            [buttonOptions]="{
                text: get(tableRow, 'button_text', ''),
                type: 'primary',
                iconPosition: 'right',
                iconName: 'chevron-right'
            }"
          ></button-component>
          <div class="preview-table">
            <img src="https://resources.exxactcorp.com/resources/exx/assets/images/table_preview.svg" />
          </div>
          <div class="preview-table-line"></div>
        </div>
      }
      <div [class.hidden]="isTableOpen || activatePreview" class="new-table-opacity">
        @if (tableType == 'tabbed_table') {
          @if (!isTableOpen && get(tableRow, 'headline', '').length > 0) {
            <div class="d-flex justify-content-center headline">
              <h2>{{ get(tableRow, 'headline', '') }}</h2>
            </div>
          }
          <div class="modal-container">
            <div [class.scroll-container]="activatePreview">
              @if (isTableOpen) {
                <button
                  class="d-flex align-items-center close-icon"
                  aria-label="Close"
                  (click)="isTableOpen = false; bsModalRef.hide()"
                  >
                  <i-feather name="x"></i-feather>
                </button>
              }
              <div id="tab-container" role="tablist" class="d-flex flex-row" appDragToScroll>
                @for (tab of get(tableRow, 'new_table_format_2.table_group[0].tables'); track tab; let i = $index) {
                  <div
                    ngClass="{{ tableIdentifier + '-tab' + ' tab' }}"
                    [class.narrow]="isNarrow"
                    [class.active-tab]="i == currentTableIndex"
                    (click)="setTable(i)"
                    role="tab"
                    [attr.aria-selected]="i == currentTableIndex"
                    tabindex="0"
                    (keydown.enter)="setTable(i)"
                    (keydown.space)="setTable(i); $event.preventDefault()"
                    >
                    <div class="d-flex flex-column align-items-center">
                      <span class="tab-text"> {{ tab.table_reference[0]?.tab_name }}</span>
                      @if (isNarrow || (!isNarrow && tabWidthExceeded) || isBlogPage) {
                        <div class="tab-underline"></div>
                      }
                    </div>
                  </div>
                }
              </div>
              @if (!isNarrow && !tabWidthExceeded && !isBlogPage) {
                <div id="tab-line">
                  <span class="tab-indicator" [style.transform]="transformAmount" [style.width]="activeTabWidthString"></span>
                </div>
              }
              <div class="two-table-container tabbed">
                <table>
                  <thead class="main-table-head">
                    <tr id="master-header">
                      @for (
                        masterHeaderColumn of get(
                        tableRow,
                        'new_table_format_2.table_group[0].tables[' + currentTableIndex + '].table_reference[0].table_header.rows[0]'
                        )
                        ; track
                        $index) {
                        @if (masterHeaderColumn.length != 0) {
                          <th>
                            <div>
                              <h6>{{ masterHeaderColumn }}</h6>
                            </div>
                          </th>
                        }
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (table of activeTable; track table; let i = $index; let last = $last) {
                      <tr>
                        @for (tableCell of table; track $index) {
                          @if (tableCell.length != 0) {
                            <td [innerHTML]="tableCell | safe: 'html'"></td>
                          }
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              @if (get(tableRow, 'new_table_format_2.table_group[0].footnote')) {
                <div
                  class="table-footnote"
                  [innerHTML]="get(tableRow, 'new_table_format_2.table_group[0].footnote')"
                ></div>
              }
            </div>
          </div>
        } @else {
          @if (tableType == 'stacked_table') {
            <div>
              @if (!isTableOpen && get(tableRow, 'headline', '').length > 0) {
                <div class="d-flex justify-content-center headline">
                  <h2>{{ get(tableRow, 'headline', '') }}</h2>
                </div>
              }
              <div class="modal-container">
                <div [class.scroll-container]="activatePreview">
                  @if (isTableOpen) {
                    <button
                      class="d-flex align-items-center close-icon"
                      aria-label="Close"
                      (click)="isTableOpen = false; bsModalRef.hide()"
                      >
                      <i-feather name="x"></i-feather>
                    </button>
                  }
                  <div class="two-table-container stacked">
                    <table>
                      <thead class="main-table-head">
                        <tr id="master-header">
                          @for (masterHeaderColumn of get(tableRow, 'new_table_format_2.table_group[0].master_header.rows[0]'); track $index) {
                            @if (masterHeaderColumn.length != 0) {
                              <th>
                                <div>
                                  <h6>{{ masterHeaderColumn }}</h6>
                                </div>
                              </th>
                            }
                          }
                        </tr>
                      </thead>
                      <tbody>
                      <tr class="empty-row"></tr>
                      @for (table of get(tableRow, 'new_table_format_2.table_group[0].tables'); track table; let last = $last) {
                        <tr class="subtab">
                          <th [attr.colspan]="30">
                            {{ table.table_reference[0].tab_name }}
                          </th>
                        </tr>
                        @for (tableRow of table.table_reference[0].table.rows; track tableRow; let i = $index) {
                          <ng-container class="content">
                            <tr>
                              @for (tableCell of tableRow; track $index) {
                                @if (tableCell.length > 0) {
                                  <td [innerHTML]="tableCell | safe: 'html'"></td>
                                }
                              }
                            </tr>
                          </ng-container>
                        }
                        @if (!last) {
                          <tr class="empty-row">
                            <th [attr.colspan]="30">&nbsp;</th>
                          </tr>
                        }
                      }
                      </tbody>
                    </table>
                  </div>
                  @if (get(tableRow, 'new_table_format_2.table_group[0].footnote').length > 0) {
                    <div
                      class="table-footnote"
                      [innerHTML]="get(tableRow, 'new_table_format_2.table_group[0].footnote')"
                    ></div>
                  }
                </div>
              </div>
            </div>
          } @else {
            <div [class.invalid-table]="tabbedAndStackedLength < 2 && tableType == 'tabbed_and_stacked'">
              @if (!isTableOpen && get(tableRow, 'headline', '').length > 0) {
                <div class="d-flex justify-content-center headline">
                  <h2>{{ get(tableRow, 'headline', '') }}</h2>
                </div>
              }
              <div class="modal-container">
                <div [class.scroll-container]="activatePreview">
                  @if (isTableOpen) {
                    <button
                      class="d-flex align-items-center close-icon"
                      aria-label="Close"
                      (click)="isTableOpen = false; bsModalRef.hide()"
                      >
                      <i-feather name="x"></i-feather>
                    </button>
                  }
                  <div id="tab-container" role="tablist" class="d-flex flex-row" appDragToScroll>
                    @for (tab of get(tableRow, 'new_table_format_2.table_group'); track tab; let i = $index) {
                      <div
                        (click)="setTable(i)"
                        ngClass="{{ tableIdentifier + '-tab' + ' tab' }}"
                        [class.narrow]="isNarrow"
                        [class.active-tab]="i == currentTableIndex"
                        role="tab"
                        [attr.aria-selected]="i == currentTableIndex"
                        tabindex="0"
                        (keydown.enter)="setTable(i)"
                        (keydown.space)="setTable(i); $event.preventDefault()"
                        >
                        <div class="d-flex flex-column align-items-center">
                          <span class="tab-text"> {{ tab.tabbed_and_stacked_tab_name }}</span>
                          @if (isNarrow || (!isNarrow && tabWidthExceeded) || isBlogPage) {
                            <div class="tab-underline"></div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                  @if (!isNarrow && !tabWidthExceeded && !isBlogPage) {
                    <div id="tab-line">
                      <span class="tab-indicator" [style.transform]="transformAmount" [style.width]="activeTabWidthString"></span>
                    </div>
                  }
                  <div class="two-table-container" [class.stacked]="tableType == 'stacked_table'" [class.tabbed]="tableType == 'tabbed_table'">
                    <table>
                      <thead class="main-table-head">
                        <tr id="master-header">
                          @for (
                            masterHeaderColumn of get(
                            tableRow,
                            'new_table_format_2.table_group[' + currentTableIndex + '].master_header.rows[0]'
                            )
                            ; track
                            $index) {
                            <th>
                              <div>
                                <h6>{{ masterHeaderColumn }}</h6>
                              </div>
                            </th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="empty-row-small"></tr>
                        @for (table of activeTable; track table; let last = $last) {
                          <tr class="subtab">
                            <th [attr.colspan]="30">
                              {{ table.table_reference[0].tab_name }}
                            </th>
                          </tr>
                          @for (tableRow of table.table_reference[0].table.rows; track tableRow; let i = $index) {
                            <ng-container class="content">
                              <tr>
                                @for (tableCell of tableRow; track $index) {
                                  <td [innerHTML]="tableCell | safe: 'html'"></td>
                                }
                              </tr>
                            </ng-container>
                          }
                          @if (!last) {
                            <tr class="empty-row">
                              <th [attr.colspan]="30">&nbsp;</th>
                            </tr>
                          }
                        }
                      </tbody>
                    </table>
                  </div>
                  <div
                    class="table-footnote"
                    innerHTML="{{ get(tableRow, 'new_table_format_2.table_group[' + currentTableIndex + '].footnote', '') }}"
                  ></div>
                </div>
              </div>
            </div>
          }
        }
        <ng-template #partTwo>
          @if (tableType == 'stacked_table') {
            <div>
              @if (!isTableOpen && get(tableRow, 'headline', '').length > 0) {
                <div class="d-flex justify-content-center headline">
                  <h2>{{ get(tableRow, 'headline', '') }}</h2>
                </div>
              }
              <div class="modal-container">
                <div [class.scroll-container]="activatePreview">
                  @if (isTableOpen) {
                    <button
                      class="d-flex align-items-center close-icon"
                      aria-label="Close"
                      (click)="isTableOpen = false; bsModalRef.hide()"
                      >
                      <i-feather name="x"></i-feather>
                    </button>
                  }
                  <div class="two-table-container stacked">
                    <table>
                      <thead class="main-table-head">
                        <tr id="master-header">
                          @for (masterHeaderColumn of get(tableRow, 'new_table_format_2.table_group[0].master_header.rows[0]'); track $index) {
                            @if (masterHeaderColumn.length != 0) {
                              <th>
                                <div>
                                  <h6>{{ masterHeaderColumn }}</h6>
                                </div>
                              </th>
                            }
                          }
                        </tr>
                      </thead>
                      <tbody>
                      <tr class="empty-row"></tr>
                      @for (table of get(tableRow, 'new_table_format_2.table_group[0].tables'); track table; let last = $last) {
                        <tr class="subtab">
                          <th [attr.colspan]="30">
                            {{ table.table_reference[0].tab_name }}
                          </th>
                        </tr>
                        @for (tableRow of table.table_reference[0].table.rows; track tableRow; let i = $index) {
                          <ng-container class="content">
                            <tr>
                              @for (tableCell of tableRow; track $index) {
                                @if (tableCell.length > 0) {
                                  <td [innerHTML]="tableCell | safe: 'html'"></td>
                                }
                              }
                            </tr>
                          </ng-container>
                        }
                        @if (!last) {
                          <tr class="empty-row">
                            <th [attr.colspan]="30">&nbsp;</th>
                          </tr>
                        }
                      }
                      </tbody>
                    </table>
                  </div>
                  @if (get(tableRow, 'new_table_format_2.table_group[0].footnote').length > 0) {
                    <div
                      class="table-footnote"
                      [innerHTML]="get(tableRow, 'new_table_format_2.table_group[0].footnote')"
                    ></div>
                  }
                </div>
              </div>
            </div>
          } @else {
            <div [class.invalid-table]="tabbedAndStackedLength < 2 && tableType == 'tabbed_and_stacked'">
              @if (!isTableOpen && get(tableRow, 'headline', '').length > 0) {
                <div class="d-flex justify-content-center headline">
                  <h2>{{ get(tableRow, 'headline', '') }}</h2>
                </div>
              }
              <div class="modal-container">
                <div [class.scroll-container]="activatePreview">
                  @if (isTableOpen) {
                    <button
                      class="d-flex align-items-center close-icon"
                      aria-label="Close"
                      (click)="isTableOpen = false; bsModalRef.hide()"
                      >
                      <i-feather name="x"></i-feather>
                    </button>
                  }
                  <div id="tab-container" role="tablist" class="d-flex flex-row" appDragToScroll>
                    @for (tab of get(tableRow, 'new_table_format_2.table_group'); track tab; let i = $index) {
                      <div
                        (click)="setTable(i)"
                        ngClass="{{ tableIdentifier + '-tab' + ' tab' }}"
                        [class.narrow]="isNarrow"
                        [class.active-tab]="i == currentTableIndex"
                        role="tab"
                        [attr.aria-selected]="i == currentTableIndex"
                        tabindex="0"
                        (keydown.enter)="setTable(i)"
                        (keydown.space)="setTable(i); $event.preventDefault()"
                        >
                        <div class="d-flex flex-column align-items-center">
                          <span class="tab-text"> {{ tab.tabbed_and_stacked_tab_name }}</span>
                          @if (isNarrow || (!isNarrow && tabWidthExceeded) || isBlogPage) {
                            <div class="tab-underline"></div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                  @if (!isNarrow && !tabWidthExceeded && !isBlogPage) {
                    <div id="tab-line">
                      <span class="tab-indicator" [style.transform]="transformAmount" [style.width]="activeTabWidthString"></span>
                    </div>
                  }
                  <div class="two-table-container" [class.stacked]="tableType == 'stacked_table'" [class.tabbed]="tableType == 'tabbed_table'">
                    <table>
                      <thead class="main-table-head">
                        <tr id="master-header">
                          @for (
                            masterHeaderColumn of get(
                            tableRow,
                            'new_table_format_2.table_group[' + currentTableIndex + '].master_header.rows[0]'
                            )
                            ; track
                            $index) {
                            <th>
                              <div>
                                <h6>{{ masterHeaderColumn }}</h6>
                              </div>
                            </th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="empty-row-small"></tr>
                        @for (table of activeTable; track table; let last = $last) {
                          <tr class="subtab">
                            <th [attr.colspan]="30">
                              {{ table.table_reference[0].tab_name }}
                            </th>
                          </tr>
                          @for (tableRow of table.table_reference[0].table.rows; track tableRow; let i = $index) {
                            <ng-container class="content">
                              <tr>
                                @for (tableCell of tableRow; track $index) {
                                  <td [innerHTML]="tableCell | safe: 'html'"></td>
                                }
                              </tr>
                            </ng-container>
                          }
                          @if (!last) {
                            <tr class="empty-row">
                              <th [attr.colspan]="30">&nbsp;</th>
                            </tr>
                          }
                        }
                      </tbody>
                    </table>
                  </div>
                  <div
                    class="table-footnote"
                    innerHTML="{{ get(tableRow, 'new_table_format_2.table_group[' + currentTableIndex + '].footnote', '') }}"
                  ></div>
                </div>
              </div>
            </div>
          }
        </ng-template>
      </div>
    </div>
  }
</section>
<ng-template #tablePreview>
  <div
    id="preview-table-container"
    class="d-flex flex-column align-items-center"
    [class.invalid-preview]="tabbedAndStackedLength < 2 && tableType == 'tabbed_and_stacked'"
    >
    <h2>{{ get(tableRow, 'headline', '') }}</h2>
    <button-component
      class="preview-button"
      (click)="openTable(tableTypeRef); isTableOpen = true"
            [buttonOptions]="{
                text: get(tableRow, 'button_text', ''),
                type: 'primary',
                iconPosition: 'right',
                iconName: 'chevron-right'
            }"
    ></button-component>
    <div class="preview-table">
      <img src="https://resources.exxactcorp.com/resources/exx/assets/images/table_preview.svg" />
    </div>
    <div class="preview-table-line"></div>
  </div>
</ng-template>

<ng-template #stackedTable>
  <div>
    @if (!isTableOpen && get(tableRow, 'headline', '').length > 0) {
      <div class="d-flex justify-content-center headline">
        <h2>{{ get(tableRow, 'headline', '') }}</h2>
      </div>
    }
    <div class="modal-container">
      <div [class.scroll-container]="activatePreview">
        @if (isTableOpen) {
          <button
            class="d-flex align-items-center close-icon"
            aria-label="Close"
            (click)="isTableOpen = false; bsModalRef.hide()"
            >
            <i-feather name="x"></i-feather>
          </button>
        }

        <div class="two-table-container" [class.stacked]="tableType == 'stacked_table'" [class.tabbed]="tableType == 'tabbed_table'">
          <table>
            <thead class="main-table-head">
              <tr id="master-header">
                @for (masterHeaderColumn of get(tableRow, 'new_table_format_2.table_group[0].master_header.rows[0]'); track $index) {
                  @if (masterHeaderColumn.length != 0) {
                    <th>
                      <div>
                        <h6>{{ masterHeaderColumn }}</h6>
                      </div>
                    </th>
                  }
                }
              </tr>
            </thead>
            <tbody>
            <tr class="empty-row"></tr>

            @for (table of get(tableRow, 'new_table_format_2.table_group[0].tables'); track table; let last = $last) {
              <tr class="subtab">
                <th [attr.colspan]="30">
                  {{ table.table_reference[0].tab_name }}
                </th>
              </tr>
              @for (tableRow of table.table_reference[0].table.rows; track tableRow; let i = $index) {
                <ng-container class="content">
                  <tr>
                    @for (tableCell of tableRow; track $index) {
                      @if (tableCell.length > 0) {
                        <td [innerHTML]="tableCell | safe: 'html'"></td>
                      }
                    }
                  </tr>
                </ng-container>
              }
              @if (!last) {
                <tr class="empty-row">
                  <th [attr.colspan]="30">&nbsp;</th>
                </tr>
              }
            }
            </tbody>
          </table>
        </div>
        @if (get(tableRow, 'new_table_format_2.table_group[0].footnote').length > 0) {
          <div
            class="table-footnote"
            [innerHTML]="get(tableRow, 'new_table_format_2.table_group[0].footnote')"
          ></div>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #tabbedTable>
  @if (!isTableOpen && get(tableRow, 'headline', '').length > 0) {
    <div class="d-flex justify-content-center headline">
      <h2>{{ get(tableRow, 'headline', '') }}</h2>
    </div>
  }
  <div class="modal-container">
    <div [class.scroll-container]="activatePreview">
      @if (isTableOpen) {
        <button
          class="d-flex align-items-center close-icon"
          aria-label="Close"
          (click)="isTableOpen = false; bsModalRef.hide()"
          >
          <i-feather name="x"></i-feather>
        </button>
      }

      <div id="tab-container" role="tablist" class="d-flex flex-row" appDragToScroll>
        @for (tab of get(tableRow, 'new_table_format_2.table_group[0].tables'); track tab; let i = $index) {
          <div role="tab" [attr.aria-selected]="i == currentTableIndex"
            ngClass="{{ tableIdentifier + '-tab' + ' tab' }}"
            [class.narrow]="isNarrow"
            [class.active-tab]="i == currentTableIndex"
            (click)="setTable(i)"
            tabindex="0"
            (keydown.enter)="setTable(i)"
            (keydown.space)="setTable(i); $event.preventDefault()"
            >
            <div class="d-flex flex-column align-items-center">
              <span class="tab-text"> {{ tab.table_reference[0]?.tab_name }}</span>
              @if (isNarrow || (!isNarrow && tabWidthExceeded) || isBlogPage) {
                <div class="tab-underline"></div>
              }
            </div>
          </div>
        }
      </div>
      @if (!isNarrow && !tabWidthExceeded && !isBlogPage) {
        <div id="tab-line">
          <span class="tab-indicator" [style.transform]="transformAmount" [style.width]="activeTabWidthString"></span>
        </div>
      }

      <div class="two-table-container" [class.stacked]="tableType == 'stacked_table'" [class.tabbed]="tableType == 'tabbed_table'">
        <table>
          <thead class="main-table-head">
            <tr id="master-header">
              @for (
                masterHeaderColumn of get(
                tableRow,
                'new_table_format_2.table_group[0].tables[' + currentTableIndex + '].table_reference[0].table_header.rows[0]'
                )
                ; track
                $index) {
                @if (masterHeaderColumn.length != 0) {
                  <th>
                    <div>
                      <h6>{{ masterHeaderColumn }}</h6>
                    </div>
                  </th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @for (table of activeTable; track table; let i = $index; let last = $last) {
              <tr>
                @for (tableCell of table; track $index) {
                  @if (tableCell.length != 0) {
                    <td [innerHTML]="tableCell | safe: 'html'"></td>
                  }
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
      @if (get(tableRow, 'new_table_format_2.table_group[0].footnote')) {
        <div
          class="table-footnote"
          [innerHTML]="get(tableRow, 'new_table_format_2.table_group[0].footnote')"
        ></div>
      }
    </div>
  </div>
</ng-template>

<ng-template #tabbedAndStackedTable>
  <div [class.invalid-table]="tabbedAndStackedLength < 2 && tableType == 'tabbed_and_stacked'">
    @if (!isTableOpen && get(tableRow, 'headline', '').length > 0) {
      <div class="d-flex justify-content-center headline">
        <h2>{{ get(tableRow, 'headline', '') }}</h2>
      </div>
    }
    <div class="modal-container">
      <div [class.scroll-container]="activatePreview">
        @if (isTableOpen) {
          <button
            class="d-flex align-items-center close-icon"
            aria-label="Close"
            (click)="isTableOpen = false; bsModalRef.hide()"
            >
            <i-feather name="x"></i-feather>
          </button>
        }
        <div id="tab-container" role="tablist" class="d-flex flex-row" appDragToScroll>
          @for (tab of get(tableRow, 'new_table_format_2.table_group'); track tab; let i = $index) {
            <div role="tab" [attr.aria-selected]="i == currentTableIndex"
              (click)="setTable(i)"
              ngClass="{{ tableIdentifier + '-tab' + ' tab' }}"
              [class.narrow]="isNarrow"
              [class.active-tab]="i == currentTableIndex"
              tabindex="0"
              (keydown.enter)="setTable(i)"
              (keydown.space)="setTable(i); $event.preventDefault()"
              >
              <div class="d-flex flex-column align-items-center">
                <span class="tab-text"> {{ tab.tabbed_and_stacked_tab_name }}</span>
                @if (isNarrow || (!isNarrow && tabWidthExceeded) || isBlogPage) {
                  <div class="tab-underline"></div>
                }
              </div>
            </div>
          }
        </div>
        @if (!isNarrow && !tabWidthExceeded && !isBlogPage) {
          <div id="tab-line">
            <span class="tab-indicator" [style.transform]="transformAmount" [style.width]="activeTabWidthString"></span>
          </div>
        }
        <div class="two-table-container" [class.stacked]="tableType == 'stacked_table'" [class.tabbed]="tableType == 'tabbed_table'">
          <table>
            <thead class="main-table-head">
              <tr id="master-header">
                @for (
                  masterHeaderColumn of get(
                  tableRow,
                  'new_table_format_2.table_group[' + currentTableIndex + '].master_header.rows[0]'
                  )
                  ; track
                  $index) {
                  <th>
                    <div>
                      <h6>{{ masterHeaderColumn }}</h6>
                    </div>
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              <tr class="empty-row-small"></tr>
              @for (table of activeTable; track table; let last = $last) {
                <tr class="subtab">
                  <th [attr.colspan]="30">
                    {{ table.table_reference[0].tab_name }}
                  </th>
                </tr>
                @for (tableRow of table.table_reference[0].table.rows; track tableRow; let i = $index) {
                  <ng-container class="content">
                    <tr>
                      @for (tableCell of tableRow; track $index) {
                        <td [innerHTML]="tableCell | safe: 'html'"></td>
                      }
                    </tr>
                  </ng-container>
                }
                @if (!last) {
                  <tr class="empty-row">
                    <th [attr.colspan]="30">&nbsp;</th>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
        <div
          class="table-footnote"
          innerHTML="{{ get(tableRow, 'new_table_format_2.table_group[' + currentTableIndex + '].footnote', '') }}"
        ></div>
      </div>
    </div>
  </div>
</ng-template>
